import { NodeViewContextableWrapper } from "@ext/markdown/core/element/NodeViewContextableWrapper";
import { useBlockToolbar } from "@ext/markdown/elements/article/edit/helpers/useBlockToolbar";
import InlineImage from "@ext/markdown/elements/inlineImage/render/components/InlineImage";
import type { NodeViewProps } from "@tiptap/react";
import InlineImageActions from "./InlineImageActions";

const InlineImageComponent = (props: NodeViewProps) => {
	const { node, editor } = props;
	useBlockToolbar(
		props,
		<InlineImageActions
			toBlock={() => {
				if (!editor || editor.isDestroyed) return;
				editor.chain().focus().inlineImageToBlock().run();
			}}
		/>,
		{ comment: true },
	);

	return (
		<NodeViewContextableWrapper as="span" data-drag-handle props={props}>
			<InlineImage
				alt={node.attrs.alt}
				commentId={node.attrs.comment?.id}
				height={node.attrs.height}
				src={node.attrs.src}
				width={node.attrs.width}
			/>
		</NodeViewContextableWrapper>
	);
};

export default InlineImageComponent;
